import { BiVizType } from '@euler/model/bi/viz';
import {
  AlignCenterHorizontal,
  ChartArea,
  ChartBar,
  ChartColumn,
  ChartColumnStacked,
  ChartLine,
  ChartPie,
  Funnel,
  Gauge,
  Hexagon,
  LayoutGrid,
  LucideIcon,
  Table2,
} from 'lucide-react-native';

const kIcons: Record<BiVizType, LucideIcon> = {
  [BiVizType.Line]: ChartLine,
  [BiVizType.Area]: ChartArea,
  [BiVizType.Bar]: ChartColumn,
  [BiVizType.HorizontalBar]: ChartBar,
  [BiVizType.StackedBar]: ChartColumnStacked,
  [BiVizType.Pie]: ChartPie,
  [BiVizType.Donut]: ChartPie,
  [BiVizType.Radar]: Hexagon,
  [BiVizType.Pyramid]: AlignCenterHorizontal,
  [BiVizType.Funnel]: Funnel,
  [BiVizType.Table]: Table2,
  [BiVizType.Kpi]: Gauge,
  [BiVizType.KpiGroup]: LayoutGrid,
};

/** The card icon for a viz; a type this build does not know gets a bar. */
export function biVizIcon(type: BiVizType): LucideIcon {
  return kIcons[type] ?? ChartColumn;
}
